export default __webpack_public_path__ + "static/image7-db548c20130d80d952878c0d02079b52.jpg";